var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.temp)?_c('div',{staticClass:"project-transition",class:[_vm.animation]},[_c('ProjectIntro',{staticClass:"--no-image",attrs:{"project":_vm.temp}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }